import React, { useState } from "react";
import Header from "../components/Header";
import HeroSection from "../components/HeroSection";
import AboutSection from "../components/AboutSection";
import ServicesSection from "../components/ServicesSection";
import TestimonialsSection from "../components/TestimonialsSection";
import PricingSection from "../components/PricingSection";
import SocialMediaSection from "../components/SocialMediaSection";
import ContactSection from "../components/ContactSection";
import Footer from "../components/Footer";
import CookieConsent from "../components/CookieConsent";
import MatrixPopup from "../components/MatrixPopup";

const HomePage = () => {
  return (
    <div className="min-h-screen bg-cream-light">
      <MatrixPopup />
      <CookieConsent />
      <Header />
      <HeroSection />
      <AboutSection />
      <ServicesSection />
      <TestimonialsSection />
      <PricingSection />
      <SocialMediaSection />
      <ContactSection />
      <Footer />
    </div>
  );
};

export default HomePage;